export default {
    titleContainer: {
        backgroundColor: "#04BAD8",
    },
    title: {
        color: "#000000",
        fontWeight: 700
    }
};
